module.exports = __webpack_public_path__ + "img/logo.1a3d5047.svg";